import { Modal as AntdModal } from "antd";
import type { ModalProps } from "antd";

export const Modal = ({
  footer = null,
  width = 600,
  styles,
  ...props
}: ModalProps) => {
  return (
    <AntdModal
      footer={footer}
      width={width}
      styles={{
        container: { padding: 0 },
        ...styles,
      }}
      {...props}
    />
  );
};
